import React, { useState } from "react";
import { Tab, Nav, Form } from "react-bootstrap";
import Pagination from "react-bootstrap/Pagination";
import { Link, useNavigate } from "react-router-dom";
import clientimg from "../../asset/images/onboarding-pending/client-img.jpg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import Loader from "../../Components/Common/Loader";

import {
  getName,
  getTabStatus,
  goToClientDashboard,
  mobileNumber,
  noDataFound,
  splitDate,
} from "../../CommonMethhods/CommonMethods";
import { Constants } from "../../CommonMethhods/Constants";

function OnboardingCompleted(props) {
  let checkCompleted = props.checkCompleted;
  // console.table("checkCompleted", props);
  let linecard = props.linecard;

  const [show, setShow] = useState(false);
  let navigate = useNavigate();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  let serverError = props.serverError;
  let filteredCompleted = [];

  filteredCompleted =
    checkCompleted.length > 0
      ? checkCompleted.filter((element) => {
          if (element.clienttype == props.onboardingFilter) {
            return element;
          }
        })
      : [];

  return (
    <>
      <Tab.Pane eventKey="Completed" className="completedClass">
        <div className="row">
          <div className="col-12">
            <div
              className="oboarding-block-wrapper card-box alert-table text-center"
              onScroll={(e) => props.handleScroll(e)}
            >
              {filteredCompleted.length > 0 ? (
                <div
                  className={` ${
                    linecard === "block-active col-division-5"
                      ? "onboarding-card-wrapper"
                      : ""
                  }`}
                >
                  {filteredCompleted.map((item, index) => {
                    return (
                      <div
                        className={`w-100 bottom-25 ${linecard}`}
                        key={index}
                      >
                        <a
                          onClick={() => {
                            goToClientDashboard(item.clientCode, item.pan);
                            getTabStatus(props.filterData)
                            navigate("/client-dashboard");

                          }}
                          className="view-detail-btn"
                        >
                          <div className="card-box onboarding-card">
                            <div className="client-img-checkbox-wrapper">
                              <div className="client-img-wrapper">
                                <div className="profile-image">
                                  {item?.clientname
                                    ? getName(item?.clientname)
                                    : "N.A"}
                                </div>

                                {/* <img src={clientimg} alt="" /> */}
                              </div>
                            </div>
                            <div className="onboarding-card-content">
                              <div className="onboarding-card-top">
                                <div className="user-email-wrapper">
                                  <p className="username">
                                    <span>{item?.clientname || "N.A"}</span>
                                  </p>{" "}
                                  <p className="email">
                                    {item?.emailid ? item?.emailid : "N.A"}
                                  </p>
                                </div>
                                <ul className="onboarding-content-link-list">
                                  {/* <li className="fingerprint-icon-wrapper">
                                    <span className="icon-fingerprint fingerprint-icon"></span>
                                  </li> */}
                                  {/* <li className="user-icon-wrapper">
                                    <span className="icon-verified-user"></span>
                                  </li> */}
                                  {/* <li className="onboard-info">
                                                    <Link to="#">OB Screen - Onboard Info</Link>
                                                </li> */}
                                  {/* <li className="onboard-new-link">
                                    <Link to="#" className="">
                                      {Constants.New}
                                    </Link>
                                  </li> */}
                                </ul>
                              </div>
                              {/* <div className="view-btn-wrapper">
                                                        <a target='_blank' href="/Client-Dashboard" className="view-detail-btn">View Details</a>
                                                    </div> */}

                              <div className="clientname-info">
                                <ul className="call-web-wrapper">
                                  <li className="created-time-wrapper">
                                    {/* <div > */}
                                    <span className="icon-calendar onboard-pending-icon"></span>
                                    <span className="onboard-sm-icon-label">
                                      <span>
                                        {item?.createddatetime
                                          ? splitDate(item?.createddatetime)
                                          : "N.A"}
                                      </span>
                                    </span>
                                    {/* </div> */}
                                  </li>
                                  <li className="created-time-wrapper">
                                    {/* <div > */}
                                    <span className="icon-client-code onboard-pending-icon"></span>
                                    <span className="onboard-sm-icon-label">
                                      <span>{item?.clientCode || "N.A"}</span>
                                    </span>
                                    {/* </div> */}
                                  </li>
                                </ul>

                                <div className="client-info-status">
                                  <ul className="call-web-wrapper">
                                    <li>
                                      <span className="icon-phone-icon onboard-pending-icon"></span>
                                      <span className="onboard-sm-icon-label">
                                        <span>
                                          {item?.mobile ? item?.mobile : "N.A"}
                                        </span>
                                      </span>
                                    </li>
                                    {/* <li>
                                     
                                    </li> */}
                                    <li>
                                      <span className="icon-android onboard-pending-icon"></span>
                                      <span className="onboard-sm-icon-label">
                                        <span>
                                          {item?.pan
                                            ? mobileNumber(item?.pan)
                                            : "N.A"}
                                        </span>
                                      </span>
                                    </li>
                                  </ul>
                                  {/* <ul className="call-lead-stauts-wrapper"> */}
                                  {/* <li>
                                                        <div>
                                                            <span className="icon-phone-call onboard-pending-icon">
                                                            </span>
                                                            <span className="onboard-sm-icon-label">
                                                                Call Status
                                                            </span>
                                                        </div>
                                                        <div className="call-status">
                                                            <Form.Select aria-label="Default select example" className="select">
                                                                <option>Unable to Connect</option>
                                                                <option value="1">One</option>
                                                                <option value="2">Two</option>
                                                                <option value="3">Three</option>
                                                                </Form.Select>
                                                        </div>
                                                    </li> */}
                                  {/* <li>
                                                        <div>
                                                            <span className="icon-doc-file onboard-pending-icon">
                                                            </span>
                                                            <span className="onboard-sm-icon-label onboard-pending-icon">
                                                                Lead Status
                                                                </span>
                                                        </div>
                                                        <div className="call-status">
                                                            <Form.Select aria-label="Default select example" className="select">
                                                            <option>Bank Proof Missing/Invalid</option>
                                                                <option value="1">One</option>
                                                                <option value="2">Two</option>
                                                                <option value="3">Three</option>
                                                            </Form.Select>
                                                        </div>
                                                    </li> */}
                                  {/* <li>
                                                        <div>
                                                            <span className="icon-client-user onboard-pending-icon">
                                                            </span>
                                                            <span className="onboard-sm-icon-label onboard-pending-icon">
                                                                Change Assignee
                                                            </span>
                                                        </div>
                                                        <div className="call-status">
                                                            <Form.Select aria-label="Default select example" className="select">
                                                                <option>Robin Singh Chadda</option>
                                                                <option value="1">One</option>
                                                                <option value="2">Two</option>
                                                                <option value="3">Three</option>
                                                                </Form.Select>
                                                        </div>
                                                    </li> */}
                                  {/* </ul> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    );
                  })}
                </div>
              ) : (
                serverError && (
                  <h4 className="alert-title mb-0">
                    {noDataFound(serverError)}
                  </h4>
                )
              )}
              {props.scrollLoader && (
                <div className="loader-center">
                  {/* <div className="loader-alignment"> */}
                  <Loader />
                  {/* </div> */}
                </div>
              )}
            </div>
          </div>
        </div>
      </Tab.Pane>
    </>
  );
}

export default OnboardingCompleted;
